import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import MemoryIcon from '@mui/icons-material/Memory';
import ScienceIcon from '@mui/icons-material/Science';
import { Table } from '../../components';
import FirmwareVersions from '../firmwarePolicies/FirmwareVersions';
import { getFirmwareVersionColumns, getTestDevicesColumns } from './columns';
import { groupFirmwareByVersion, summarizeTestDevices } from './utils';

const IdleState = ({ firmware, firmwareError, testDevices, onStart, actionLoading }) => {
  const versions = useMemo(() => groupFirmwareByVersion(firmware), [firmware]);
  const versionSummary = useMemo(() => summarizeTestDevices(testDevices), [testDevices]);
  const hasTestDevices = testDevices.length > 0;

  const testDeviceColumns = useMemo(() => getTestDevicesColumns(), []);
  const firmwareColumns = useMemo(
    () =>
      getFirmwareVersionColumns({
        actionTitle: 'Отправить на обкатку',
        onAction: onStart,
        isDisabled: () => !hasTestDevices,
        actionLoading,
      }),
    [actionLoading, hasTestDevices, onStart]
  );

  const summaryVersions = versionSummary.map(({ version, count }) => ({
    device_model: `${count} шт.`,
    version,
  }));

  return (
    <>
      <div className="max-w-7xl mx-auto bg-white shadow-md rounded-3xl p-4 mt-6">
        <div className="flex items-center gap-2 mb-3">
          <ScienceIcon className="text-gray-500" />
          <h3 className="text-base sm:text-lg font-medium text-gray-700">Тестовый парк</h3>
        </div>
        {hasTestDevices ? (
          <p className="text-sm text-gray-500">Помечено устройств: {testDevices.length}</p>
        ) : (
          <p className="text-sm text-gray-500">
            Нет тестовых контроллеров. Отметьте их в разделе{' '}
            <Link to="/devices-update" className="text-orange-500 hover:underline">
              обновления прошивок
            </Link>
            , иначе запуск обкатки будет отклонён.
          </p>
        )}
      </div>

      {hasTestDevices && <FirmwareVersions versions={summaryVersions} title="Версии тестового парка" />}

      <Table columns={testDeviceColumns} data={testDevices} rowKey="device_id" classContainer="mt-6" />

      <div className="max-w-7xl mx-auto mt-8">
        <div className="flex items-center gap-2 px-3">
          <MemoryIcon className="text-gray-500" />
          <h3 className="text-base sm:text-lg font-medium text-gray-700">Версии в тестовом канале</h3>
        </div>
      </div>
      <Table columns={firmwareColumns} data={versions} error={firmwareError} rowKey="version" classContainer="mt-4" />
    </>
  );
};

export default IdleState;
